// Copyright (C) 2021 Bystronic Laser AG

import { onMounted, onUnmounted } from 'vue';
import { connect, disconnect } from 'echarts/core';

export function useEchartsConnection(groupName: string) {
  onMounted(() => {
    connect(groupName);
  });

  onUnmounted(() => {
    disconnect(groupName);
  });
}
